import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { userMenu, isMenuItemDisabled } from '@utils/userMenu';
import { getAccessToken } from '@app/api/tokenService';

export default function PrivateRoute({ children }) {
  const location = useLocation();
  const token = getAccessToken();
  const { user, isInitialized, isUnverified, isFrozen } = useSelector(
    (state) => state.user,
  );

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isInitialized) {
    return null;
  }

  const isOpenedSection = (item) =>
    location.pathname === item.path ||
    location.pathname.startsWith(item.path + '/');

  const isBlocked = userMenu.some(
    (item) =>
      isOpenedSection(item) &&
      (isMenuItemDisabled(item, isUnverified, isFrozen) ||
        item.exclude?.includes(user.group_role)),
  );

  if (isBlocked) {
    return <Navigate to="/" replace />;
  }

  return children;
}
